// Check if string has dash only. It might be also as html format <p>-</p>
export const hasDashOnly = string => />\s*-\s*<|^-$/.test(string);

export const formatLargeWholeNumberGaps = number => number
    .toString()
    .split('')
    .reverse()
    .map((n, i) => (i % 3 === 0 ? `${n} ` : n))
    .reverse()
    .join('');
